import dayjs from "dayjs";
import { navigate } from "../../lib/router";
import { useSession } from "../../lib/session";
import { Loading, Panel } from "../../components/ui";
import { useClients, type ClientRow } from "./Clients";

type Need = { c: ClientRow; why: string[]; rank: number };

/** Today page: clients who need something from you — reviews to prepare, a touch base, a referral ask, a policy date. */
export function ClientsToCare() {
  const { can } = useSession();
  const q = useClients();
  if (!can("clients")) return null;
  const needs: Need[] = (q.data ?? []).map((c) => {
    const why: string[] = []; let rank = 9;
    if (c.review_status === "Overdue") { why.push("Annual review overdue"); rank = 0; }
    else if (c.review_status === "Prepare") { why.push(`Prepare review · ${dayjs(c.next_annual_review).format("MMM D")}`); rank = Math.min(rank, 1); }
    if (c.next_policy_date && dayjs(c.next_policy_date).diff(dayjs(), "day") <= 60) { why.push(`Policy date ${dayjs(c.next_policy_date).format("MMM D")}`); rank = Math.min(rank, 2); }
    if (c.touch_base_needed) { why.push("Touch base"); rank = Math.min(rank, 3); }
    if (c.referral_due && c.solutions > 0) { why.push("Ask for a referral"); rank = Math.min(rank, 4); }
    return { c, why, rank };
  }).filter((n) => n.why.length).sort((a, b) => a.rank - b.rank || a.c.full_name.localeCompare(b.c.full_name));
  const show = needs.slice(0, 8);
  return (
    <Panel title="Clients to care for" hint={q.data ? `${needs.length} need something` : undefined}
      actions={<button className="btn small ghost" onClick={() => navigate("/clients")}>All clients</button>}>
      {q.loading && !q.data ? <Loading rows={3} /> : show.length === 0 ? <div className="panel-body small muted">Every client is on track.</div> : (
        <ul className="task-list">
          {show.map(({ c, why }) => (
            <li key={c.person_id} className="task">
              <button className="name" onClick={() => navigate(`/clients/${c.person_id}`)}>{c.full_name}</button>
              <div className="why">{why.join(" · ")}</div>
            </li>
          ))}
        </ul>
      )}
      {needs.length > show.length && <div className="panel-body" style={{ paddingTop: 6 }}>
        <button className="btn small ghost" onClick={() => navigate("/clients?f=review")}>See all {needs.length}</button></div>}
    </Panel>
  );
}
